var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"soc-soh-scatter-container",staticClass:"soc-soh-scatter-container"})}
var staticRenderFns = []

export { render, staticRenderFns }